import script from "./PlansPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlansPage.vue?vue&type=script&setup=true&lang=ts"

import "./PlansPage.vue?vue&type=style&index=0&id=f7c598e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7c598e0"]])

export default __exports__